import { useEffect, useState } from "react";
import { useGetCarClassDetail } from "../../interfaces/carsClass";
import CommonTab from "../common/CommonTab";
import { ListDetailTemplate, OneList } from "../../styles/common";
import styled from "styled-components";
import theme from "../../styles/theme";
import { Button, TextField } from "@mui/material";
import CarsDetail from "./CarsDetail";
import Counter from "./Counter";

const Cars = ({mode, ccid}) => {

    const [tabIndex, setTabIndex] = useState(0);

    const [cars, setCars] = useState();

    const {data:carsDetail, refetch} = useGetCarClassDetail(ccid);

    useEffect(()=>{
        refetch();
    },[ccid])

    useEffect(()=>{
        if(carsDetail){
            setCars(carsDetail.cars);
        }
    },[carsDetail])

    return (
        <div style={{width:'100%',height:'calc(100% - '+(tabIndex===0?'1rem':'0.5rem')+')'}}>
            <CommonTab tabList={['차종','카운터']} onClick={setTabIndex}/>
            {tabIndex === 0 && 
                <CarsDetail mode={mode} ccid={ccid} cars={cars} />
            }
            {tabIndex === 1 && 
                <Counter mode={mode} ccid={ccid} carsDetail={carsDetail} />
            }
        </div>
    )
}

export default Cars;